"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Types;
(function (Types) {
    Types.noop = function () { };
})(Types = exports.Types || (exports.Types = {}));
//# sourceMappingURL=types.js.map